import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {TrackingContext} from '@homeaway/react-event-tracking';

import {PartnerLogoLink, PartnershipByline} from './PartnerLogo';

import './Logo.less';

function Logo({
    altText,
    hasSearch,
    image,
    link,
    partnerLogo,
    sitePartnerLogo,
    text,
    withDiscoveryRoadTrips
}) {
    // Add the context to be used for pushing edap events
    const context = useContext(TrackingContext);

    function handleClick() {
        const field = {
            actionlocation: 'header.logo'
        };

        context.trigger('header.link.click', field);
    }

    function triggerPartnerEvent() {
        const field = {
            actionlocation: 'partner.logo'
        };

        context.trigger('pageview', field);
    }

    function LogoLink() {
        if (partnerLogo && sitePartnerLogo) {
            image = sitePartnerLogo.image;
        }

        const className = classNames(
            'site-header-logo__link',
            'flex-item',
            {'has-search': hasSearch},
        );

        return (
            <a className={className} href={link} itemProp="url" title={text} onClick={handleClick}>
                <img alt={altText} className={`site-header-logo__img Header-BG img-responsive${partnerLogo ? ' site-logo' : ''}`} itemProp="logo" src={image}/>
            </a>
        );
    }

    const logoClassName = classNames(
        'site-header-logo',
        {'site-header-logo--no-padding-right': withDiscoveryRoadTrips}
    );

    return (
        <div className={logoClassName} itemScope="itemscope" itemType="https://schema.org/Organization">
            <LogoLink />

            {partnerLogo &&
                <>
                    <PartnershipByline partnerLogo={partnerLogo} />

                    <PartnerLogoLink
                        partnerLogo={partnerLogo}
                        handleClick={handleClick}
                        triggerPartnerEvent={triggerPartnerEvent}
                    />
                </>
            }

        </div>
    );
}

Logo.propTypes = {
    altText: PropTypes.string.isRequired,
    hasSearch: PropTypes.bool,
    image: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    partnerLogo: PropTypes.shape({}),
    sitePartnerLogo: PropTypes.shape({}),
    text: PropTypes.string.isRequired,
    withDiscoveryRoadTrips: PropTypes.bool
};

export {Logo};
